module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "citroen-advisor.24701b97.png";